export const PaymentOpenResponseStatus = {
  OrderNotFound: 100,
  RequiredDataMissing: 200,
  WrongOrderStatus: 300
}
